import { useMemo } from 'react';
import * as yup from 'yup';
import { FORM_LINE_TYPES } from 'src/components/ui/FormLine/constants';

export const useFormCommonNumber = (params = {}) => {
	const { values } = params;

	const initialValues = useMemo(() => {
		return {
			phone: '',
			comment: '',
			...values,
		};
	}, [values]);

	const shape = useMemo(() => {
		return {
			groups: [
				{
					id: 1,
					lines: [
						{
							id: 1,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'phone',
									label: 'Телефон',
									format: '+7 (###) ###-##-##',
									mask: '_',
								},
							},
						},
						{
							id: 2,
							field: {
								type: FORM_LINE_TYPES.textfield,
								connected: true,
								params: {
									name: 'comment',
									label: 'Комментарий',
									multiline: true,
									minRows: 4,
								},
							},
						},
					],
				},
			],
		};
	}, []);

	const validationSchema = yup.object().shape({
		phone: yup
			.string()
			.required('Телефон обязателен')
			.matches(/^((?!_).)*$/g, 'Укажите телефон полностью'),
	});

	return { shape, initialValues, validationSchema };
};
